module.exports = __webpack_public_path__ + "img/Presentation.b3db077e.jpg";